import service from "@/store/services/tipos-service";

const state = {
  list: {},
  tipo: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, tipo) => {
    state.tipo = tipo;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((role) => {
      commit("SET_RESOURCE", role);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((tipo) => {
      commit("SET_RESOURCE", tipo);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((tipo) => {
      commit("SET_RESOURCE", tipo);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.pagination.total,
  tipo: (state) => state.tipo,
  dropdown: (state) => {
    return state.list.map((tipo) => ({
      id: tipo.id,
      nombre: tipo.nombre,
    }));
  },
};

const tipos = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default tipos;
